<template>

    <div>
        <div id="allTheNav">
            <nav id="navigator" class="navbar" :class="{navbaropen: opened}">
              <span class="open-slide">
                <span @click="opened = !opened">
                  <div>
                    <div class="bar" :class="{topopen: opened}"></div>
                    <div class="bar" :class="{midopen: opened}"></div>
                    <div class="bar" :class="{botopen: opened}"></div>
                  </div>
                </span>
              </span>
            </nav>
            <div id="side-menu" class="side-nav" :class="{sidenavopen: opened}">
                <b-nav tabs>
                    <b-nav-item v-if="(userType=='admin' )"
                            class="switch articles "
                            @click="switchComponent('panne')">
                        <i class="fa-solid fa-screwdriver-wrench text-primary"></i> Panne
                    </b-nav-item>

                    <b-nav-item
                                class="switch articles "
                                @click="switchComponent('maintenance')">
                        <i class="fa-solid fa-screwdriver-wrench text-primary"></i> Maintenance
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('machineType')">
                        <i class="fa-solid fa-clipboard-user text-success"></i> Type
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('machine')">
                        <i class="fa-solid fa-fax text-info"></i> Machine
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('tache')">
                        <i class="fa-solid fa-business-time text-warning"></i> Tâche
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('statistique')">
                        <i class="fa-solid fa-chart-column text-success"></i> Statistiques
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('echeance')">
                        <i class="fa-solid fa-calendar-days text-light"></i> Echéances
                    </b-nav-item>

                    <b-nav-item v-if="(userType=='admin' )"
                                class="switch articles "
                                @click="switchComponent('user')">
                        <i class="fa-solid fa-users text-danger"></i> Utilisateurs
                    </b-nav-item>

                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('declarationChauffeur')">
                        <i class="fa-solid fa-truck text-warning"></i> Déclaration
                    </b-nav-item>

                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('declarationCarburant')">
                        <i class="fa-solid fa-oil-can text-info"></i> Carburant
                    </b-nav-item>

                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('lavageRemorque')">
                        <i class="fa-solid fa-water text-info"></i> Lavage
                    </b-nav-item>


                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('carteVehicule')">
                        <i class="fa-solid fa-address-card text-success"></i> Carte grise
                    </b-nav-item>

                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('protocole')">
                        <i class="fa-solid fa-clipboard text-success"></i> Protocole
                    </b-nav-item>


                    <b-nav-item class="switch articles " v-if="systemeClientId==2"
                                @click="switchComponent('absence')">
                        <i class="fa-solid fa-calendar-days text-warning"></i> Absence
                    </b-nav-item>

                    <b-nav-item class="switch articles "
                                @click="switchComponent('compte')">
                        <i class="fa-solid fa-home text-info"></i> Compte
                    </b-nav-item>



                    <b-nav-item class="switch" @click="refreshToken()">
                        <span class="text-danger"><i class="fa fa-power-off" aria-hidden="true"></i> Déconnexion</span>
                    </b-nav-item>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

                </b-nav>
            </div>
        </div>
    </div>

</template>

<script>
    import {bus} from '../main.js';

    export default {

        props: ['userType','systemeClientId'],
        data() {
            return {
                screenWidth: 0, opened: false, sidenavopen: null, mainopen: null,
                botopen: null, midopen: null, topopen: null, navbaropen: null
            }
        },
        methods: {
            switchComponent(comp) {
                bus.$emit('switchComp', comp);
                this.opened = !this.opened
            },
            refreshToken()
            {
                this.$emit('refreshToken')
            }
        },
        mounted() {

        },
    }
</script>

<style scoped>

    switch {
        background: none;
        border: 1px solid black;
        margin: 0;
        cursor: pointer;
    }

    switch[disabled='disabled'] {
        color: lightgray;
        border-color: lightgray;
    }

    switch:not([disabled='disabled']):hover {
        background-color: black;
        border-color: gray;
        color: lightgray;
    }

    messages {
        border-color: red;
        color: red;
    }

    notes {
        border-color: green;
        color: green;
    }

    body {
        font-family: "Arial", Serif;
        overflow-x: hidden;
    }

    .navbar {
        overflow: hidden;
        height: 63px;
    }

    .navbaropen {
        overflow: hidden;
        height: 63px;
        margin-left: 250px;
    }

    .navbar a {
        float: left;
        display: block;
        color: #f2f2f2;
        text-align: center;
        padding: 14px 16px;
        text-decoration: none;
        font-size: 17px;
    }

    .navbar ul {
        margin: 8px 0 0 0;
        list-style: none;
    }

    .navbar a:hover {
        background-color: #ddd;
        color: #000;
    }

    .side-nav {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: #111;
        opacity: 0.9;
        overflow-x: hidden;
        padding-top: 60px;
        transition: 0.3s;
    }

    .sidenavopen {
        height: 100%;
        width: 250px;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: #111;
        opacity: 0.9;
        overflow-x: hidden;
        padding-top: 60px;
        transition: 0.3s;
    }

    .side-nav a {
        padding: 10px 10px 10px 30px;
        text-decoration: none;
        font-size: 22px;
        color: #ccc;
        display: block;
        transition: 0.3s;
    }

    .side-nav a:hover {
        color: #fff;
    }

    .side-nav .btn-close {
        position: absolute;
        top: 0;
        right: 22px;
        font-size: 36px;
        margin-left: 50px;
    }

    #main {
        transition: margin-left 0.3s;
        padding: 20px;
        overflow: hidden;
        width: 100%;
    }

    .mainopen {
        transition: margin-left 0.3s;
        padding: 20px;
        overflow: hidden;
        width: 100%;
        margin-left: 250px;
    }

    nav {
        transition: margin-left 0.3s;
    }

    .bar {
        display: block;
        height: 5px;
        width: 35px;
        background: #000;
        margin: 5px auto;
    }

    .midopen {
        width: 0;
    }

    .bar {
        transition: all .3s ease;
    }

    .topopen {
        transform: translateY(10px) rotateZ(45deg);
    }

    .botopen {
        transform: translateY(-10px) rotateZ(-45deg);
    }

    #navigator {
        position: fixed;
        left: 0px;
        z-index: 1000;
    }

    #side-menu
    {
        top:50px;
    }

    .systemeClient
    {
        font-size:25px;
    }
</style>
